import React from 'react';
import { useParams } from 'react-router-dom';
import { setMatchGoal } from '../../../api/setMatchGoal';
import { getRoundMatches } from '../../../api/getRoundMatches';

import styles from './GoalForm.module.css';

function GoalForm(props) {
  const { teamId, /* againstId, */ players, setMatches } = props;
  const { leagueId, roundId, matchId } = useParams();

  const [goaler, setGoaler] = React.useState('');
  const [assister, setAssister] = React.useState('');
  const [errorText, setErrorText] = React.useState('');

  React.useEffect(() => {
    setGoaler('');
    setAssister('');
  }, [teamId]);

  const handleClickGoal = async () => {
    if (goaler === '') {
      setErrorText('לא בחרת מבקיע שער');
    } else if (assister === '') {
      setErrorText('לא בחרת מבשל שער');
    } else if (
      assister === goaler &&
      goaler !== 'selfGoal' &&
      goaler !== 'anonymous'
    ) {
      setErrorText('על המבקיע והמבשל להיות שחקנים שונים');
    } else {
      setErrorText('שומר שער...');
        const res = await setMatchGoal(
        leagueId,
        roundId,
        matchId,
        teamId,
        goaler === 'selfGoal' ? null : goaler === 'anonymous' ? '-1' : goaler,
        assister === 'noAssister'
          ? null
          : assister === 'anonymous'
          ? '-1'
          : assister,
        goaler === 'selfGoal' ? 'SELF' : 'REGULAR'
      );
      if (!res.error) {
        setErrorText('השער נשמר :)');
        setTimeout(() => {
          setErrorText('');
        }, 850);
        setGoaler('');
        setAssister('');

        const res2 = await getRoundMatches(leagueId, roundId);
        if (!res2.error) {
          setMatches(res2);
        }
      } else {
        setErrorText('השער לא נשמר - נסה שנית');
      }
    }
  };

  const handleSelectChange = (e, setDropdonwnState) => {
    const change = e.target.value;
    setDropdonwnState(change);
  };

  return (
    <div className={styles.goalForm}>
      <h3>עדכונים שערים</h3>

      <form>
        <select
          name="goaler"
          value={goaler}
          onChange={e => handleSelectChange(e, setGoaler)}
        >
          <option value="" hidden>
            מבקיע השער
          </option>

          <option value="anonymous">--- שחקן אנונימי ---</option>

          {players.map(player => (
            <option key={player.user.id} value={player.user.id}>
              {player.user.full_name}
            </option>
          ))}
          <option value="selfGoal" style={{ color: 'darkmagenta' }}>
            --- שער עצמי ---
          </option>
          {/* <option value="-2">טכני</option> */}
        </select>

        <select
          name="assister"
          value={assister}
          onChange={e => handleSelectChange(e, setAssister)}
        >
          <option value="" hidden>
            מבשל השער
          </option>

          <option value="noAssister" style={{ color: 'darkmagenta' }}>
            --- ללא בישול ---
          </option>

          {players.map(player => (
            <option key={player.user.id} value={player.user.id}>
              {player.user.full_name}
            </option>
          ))}

          <option value="anonymous">--- שחקן אנונימי ---</option>
          {/* <option value="-2">טכני</option> */}
        </select>

        <span className={styles.errorMsg}>{errorText}</span>

        <button type="button" className="btnLarge" onClick={handleClickGoal}>
          שליחת שער
        </button>
      </form>
    </div>
  );
}

export default GoalForm;
